import React from 'react'
import CampaignComponent from "../components/CampaignComponent";


export default function Campaign() {
  return (
    <CampaignComponent/>
  )
}
